import instance from "@/store/actions/instance";
import { message, Modal, Table } from "antd";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { useSelector } from "react-redux";

const WhatsappDetailCampaignModal = ({
  campaign,
  onClose,
  open,
  t,
  capitalizeFirstLetter,
}) => {
  const direction = useSelector((state) => state.config.direction);
  const [stats, setStats] = useState(null);
  const [statusLoading, setStatusLoading] = useState(true);

  async function fetchWhatsappCampaignStats() {
    try {
      const res = await instance.post("/fetch_whatsapp_campaign_stats/", {
        id: campaign.id,
      });
      setStats(res.data);
    } catch (e) {
      console.error(e);
      message.error(t("SomethingWentWrong"));
    }
    setStatusLoading(false);
  }
  useEffect(() => {
    fetchWhatsappCampaignStats();
  }, []);

  const getPurpose = (purpose) => {
    const purposeMap = {
      retain: t("Increase retention rate"),
      "increase basket": t("Increase average order value"),
      "re-engage": t("Increase engagement"),
      encourage: t("Increase sales"),
    };
    return purposeMap[purpose];
  };

  const recipients = campaign.recipients?.split(",");
  const dataSource = recipients.map((recipient, index) => ({
    key: index.toString(),
    number: recipient,
  }));

  return (
    <Modal
      title={
        <div
          className="ant-modal-title"
          style={{
            textAlign: direction === "rtl" ? "right" : "left",
          }}
        >
          {t("Campaign Details")}
        </div>
      }
      visible={open}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={onClose}
      width={800}
      bodyStyle={{
        textAlign: direction === "ltr" ? "left" : "right",
      }}
      cancelText={t("Close")}
    >
      <div className={"mt-3"}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Name")}:{" "}
        </span>
        <span>{campaign.name}</span>
      </div>
      <div className={"mt-3"}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Template")}:
        </span>
        <span> {campaign.template}</span>
      </div>

      <div className={"mt-3"}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Type")}:{" "}
        </span>
        <span>{capitalizeFirstLetter(campaign.type)}</span>
      </div>
      <div className={"mt-3"}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Segment")}:{" "}
        </span>
        <span>{capitalizeFirstLetter(campaign.segment)}</span>
      </div>
      <div className={"mt-3"}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Purpose")}:{" "}
        </span>
        <span>{getPurpose(campaign.purpose)}</span>
      </div>

      <div className={"mt-3"}>
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Targeted Customers")}:{" "}
        </span>
        <span>{recipients?.length || 0}</span>
      </div>

      <div
        style={{
          marginTop: 15,
          textAlign: direction === "ltr" ? "left" : "right",
          direction: direction,
        }}
      >
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {t("Messages Stats")}:{" "}
        </span>
        <Table
          loading={statusLoading}
          style={{
            marginTop: 5,
          }}
          dataSource={stats?.rows_count}
          size="small"
        >
          <Column
            align={"center"}
            className="px-3"
            title={t("Status")}
            dataIndex="status"
            key="status"
          />
          <Column
            align={"center"}
            className="px-3"
            title={t("Count")}
            dataIndex="count"
            key="count"
          />
        </Table>
      </div>

      {stats?.rows_errors?.length > 0 && (
        <div
          style={{
            marginTop: 15,
            textAlign: direction === "ltr" ? "left" : "right",
            direction: direction,
          }}
        >
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            {t("Error Reasons")}:{" "}
          </span>
          <Table
            style={{
              marginTop: 5,
            }}
            dataSource={stats?.rows_errors}
            size="small"
          >
            <Column
              align={"center"}
              className="px-3"
              title={t("Error")}
              dataIndex="response_message"
              key="response_message"
            />
            <Column
              align={"center"}
              className="px-3"
              title={t("Count")}
              dataIndex="count"
              key="count"
            />
          </Table>
        </div>
      )}
    </Modal>
  );
};

export default withNamespaces()(WhatsappDetailCampaignModal);
